export const colors = {
  // Primary colors
  primary: '#3b82f6',
  primaryHover: '#2563eb',
  primaryShadow: 'rgba(59, 130, 246, 0.3)',
  primaryGradient: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
  headerGradient: 'linear-gradient(135deg, #8b5cf6 0%, #3b82f6 20%, #3b82f6 50%, #0d9488 100%)',
  
  // Document type colors
  proposal: '#059669',
  note: '#d97706', 
  security: '#7c3aed',
  
  // UI colors
  success: '#10b981',
  successDark: '#059669', // Darker green for better contrast
  successLight: '#27ae60', // Lighter green for accents
  warning: '#f59e0b',
  error: '#ef4444',
  
  // Dropzone colors
  dropzoneBackground: '#f9fafb',
  dropzoneBorder: '#d1d5db',
  dropzoneBorderActive: '#9ca3af',
  dropzoneHasFileBackground: '#6b7280', // 50% darker gray when populated (Material Design compliant)
  dropzoneHoverBackground: '#eff6ff', // Blue background like highlighted text field
  
  // Navigation/Tab colors
  tab: '#6b7280',
  tabActive: '#374151',
  tabHover: '#4b5563',
  
  // Filter/Preset badge colors
  badge: {
    // Light mode (for main content area)
    light: {
      inactive: '#6b7280',
      active: '#374151',
      hover: '#4b5563'
    },
    // Dark mode (for panel content area)
    dark: {
      inactive: '#6b7280',  // Current correct color
      active: '#2a2a2a',    // Subtle dark gray for active in dark mode
      hover: '#1f1f1f'
    }
  },
  
  // Chip/Tag colors
  chip: {
    // Light mode
    light: {
      background: '#eff6ff',
      border: '#bfdbfe',
      text: '#1e40af',
      removeButton: '#3b82f6',
      removeButtonHover: '#1e40af'
    },
    // Dark mode
    dark: {
      background: '#4a4a4a',
      border: '#4b5563',
      text: '#e0e0e0',
      removeButton: '#9ca3af',
      removeButtonHover: '#d1d5db'
    }
  },
  
  // Grays
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray500: '#6b7280',
  gray900: '#111827',
};
